/**
 * Entrada de dinheiro no portal.
 *
 * O atendente digita "18,90" ou "1890"; o banco guarda centavos inteiros.
 * Converter aqui, e não espalhar parseFloat pelas telas, é o que impede um
 * preço virar R$ 1.890,00 por causa de uma vírgula.
 */
export function paraCentavos(texto: string): number | null {
  const limpo = texto.trim().replace(/[^\d,.-]/g, '')
  if (!/\d/.test(limpo)) return null
  // Com vírgula ou ponto decimal, trata como reais; sem nada, como reais também
  // (digitar "18" é R$ 18,00, não 18 centavos — é o que a pessoa espera).
  const normalizado = limpo.replace(/\.(?=\d{3}\b)/g, '').replace(',', '.')
  const valor = Number(normalizado)
  if (!Number.isFinite(valor) || valor < 0) return null
  return Math.round(valor * 100)
}

export function paraTexto(centavos: number): string {
  return (centavos / 100).toFixed(2).replace('.', ',')
}
